import type { PropsWithChildren } from 'react';
import React from 'react';

import type { ApiError, ProblemDetailsSchema } from '@/js/libs/api';
import { SubHeader, Loader } from '@/js/libs/ui';

import ErrorComponent from '../Error.tsx';
import type { NavItemProps } from './NavItem.tsx';
import NavItem from './NavItem.tsx';

type SceneSubHeaderProps = PropsWithChildren<{
  items: NavItemProps[];
  pending?: boolean;
  error?: ApiError<typeof ProblemDetailsSchema>;
}>;

const SceneSubHeader = ({ children, error, items, pending }: SceneSubHeaderProps) => {
  if (pending) {
    return <Loader type='contain' />;
  }

  if (error) {
    return <ErrorComponent error={error} />;
  }

  return (
    <SubHeader fluid>
      <SubHeader.Nav>
        {items.map((item) => (
          <NavItem key={item.to} {...item} />
        ))}
      </SubHeader.Nav>
      {children}
    </SubHeader>
  );
};

SceneSubHeader.displayName = 'SceneSubHeader';

export default React.memo(SceneSubHeader) as typeof SceneSubHeader;

export type { NavItemProps };
